module.exports = __webpack_public_path__ + "static/media/PALOSANTO_01.c5f63df4.png";